import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Tag, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function Offers() {
  const [offers, setOffers] = useState([]);
  useEffect(() => {
    api.get("/offers").then(({ data }) => setOffers(data.offers || [])).catch(() => {});
  }, []);

  if (offers.length === 0) return null;

  return (
    <section id="offers" className="bg-[#1f5d3a] py-20 md:py-24" data-testid="offers-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="eyebrow text-[#f2ece4]/80">Limited-Time</div>
            <h2 className="mt-3 font-serif text-4xl tracking-tight text-white md:text-5xl">Current partner offers</h2>
          </div>
          <p className="max-w-sm text-[#dfe9e2]">Lock your district before these expire — talk to our team today.</p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {offers.map((o, i) => (
            <motion.div key={o.id}
              initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex flex-col justify-between rounded-2xl bg-white p-7 card-shadow"
              data-testid={`offer-card-${i}`}>
              <div>
                <div className="flex items-center justify-between">
                  <div className="grid h-11 w-11 place-items-center rounded-xl bg-[#fbeee1] text-[#d46a1d]">
                    <Tag size={20} />
                  </div>
                  {o.badge && (
                    <span className="rounded-full bg-[#1f5d3a] px-3 py-1 text-xs font-semibold text-white">{o.badge}</span>
                  )}
                </div>
                <h3 className="mt-5 font-serif text-2xl text-[#202124]">{o.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#6b6a65]">{o.description}</p>
              </div>
              <a href="#franchise" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#d46a1d] hover:gap-3 transition-all">
                Claim this offer <ArrowRight size={16} />
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
